import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import {
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';
import s from './ListPlaceStep1.css';
import cs from '../commonStyle.css';

import SidePanel from './SidePanel';
import FooterButton from './FooterButton';
import AddonsManager from './AddonsManager/AddonsManager';

// Locale
import messages from '../../locale/messages';
import validateStep3 from './validateStep3';
import updateStep3 from './updateStep3';

import { getCategoryConfig } from '../../config/categoryConfig';

//images
import infoIcon from '/public/SiteIcons/priceHoverIcon.svg';
import locationIcon from '/public/SiteIcons/locationIdea.svg';
import CommonFormComponent from '../CommonField/CommonFormComponent';
import { normalizePrice } from '../EditProfileForm/normalizePhone';

const GET_LISTING_ADDONS = gql`
  query getListingAddons($listId: Int!) {
    getListingAddons(listId: $listId) {
      id
      name
      description
      price
      priceType
      isActive
    }
  }
`;

class Pricing extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    listId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      addons: [],
      addonsLoaded: false,
    };
  }

  componentDidMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
    this.loadAddons();
  }

  componentDidUpdate(prevProps) {
    // If addons data just loaded from GraphQL
    if (prevProps.addonsData?.loading && !this.props.addonsData?.loading && !this.state.addonsLoaded) {
      this.loadAddons();
    }
  }

  loadAddons = () => {
    const { addonsData, dispatch } = this.props;
    if (addonsData && !addonsData.loading && addonsData.getListingAddons) {
      const addons = addonsData.getListingAddons.map(addon => ({
        id: addon.id,
        name: addon.name,
        description: addon.description,
        price: addon.price,
        priceType: addon.priceType,
      }));
      this.setState({ addons, addonsLoaded: true });
      // Store addons in redux-form for submission
      dispatch(change('ListPlaceStep3', 'listingAddons', JSON.stringify(addons)));
    }
  };

  UNSAFE_componentWillMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid } = nextProps;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  handleAddonsChange = (addons) => {
    const { dispatch } = this.props;
    this.setState({ addons });
    // Store addons in redux-form for submission
    dispatch(change('ListPlaceStep3', 'listingAddons', JSON.stringify(addons)));
  };

  render() {
    const { handleSubmit, nextPage, previousPage, formPage, step, availableCurrencies, siteSettingStatus, listId, categoryType } = this.props;
    const categoryConfig = getCategoryConfig(categoryType || 'boat');
    const { formatMessage } = this.props.intl;
    const { isDisabled, addons } = this.state;

    let isSecurityPreference = siteSettingStatus?.securityDepositPreference == 2 ? false : true;

    return (
      <div className={cx(s.stepGrid, 'stepGridRTL')}>
        <SidePanel
          title={formatMessage(messages.step3Heading)}
          landingContent={formatMessage(messages.setPricingText)}
        />
        <form onSubmit={handleSubmit}>
          <div className={s.landingMainContent}>
            <FormGroup className={cs.spaceBottom4}>
              <ControlLabel className={s.landingLabel}>
                <FormattedMessage {...messages.currency} />
              </ControlLabel>
              <Field name="currency" component={CommonFormComponent} inputClass={cx(s.formControlSelect, s.jumboSelect)} >
                {
                  availableCurrencies.map((currency, key) => {
                    if (currency.isEnable === true) {
                      return <option key={key} value={currency.symbol}>{currency.symbol}</option>
                    }
                  })
                }
              </Field>
            </FormGroup>
            <FormGroup className={cx(s.space1)}>
              <ControlLabel className={s.landingLabel}>
                <FormattedMessage {...messages.basePrice} />
                <div className={s.infoIconCss}>
                  <img src={infoIcon} className={s.infoIcon} />
                  <div className={cx(s.infoContent, s.basePriceInfo, 'infoContentRTL')}>{formatMessage(messages.basePriceInfo)}</div>
                </div>
              </ControlLabel>



            </FormGroup>
            <FormGroup className={cx(s.noMargin)}>
              <Field
                name="basePrice"
                type="text"
                component={CommonFormComponent}
                label={formatMessage(messages.basePriceLabel2)}
                inputClass={cx(s.formControlInput, s.jumboSelect, s.formControlInputMaxWidth)}
                normalize={normalizePrice}
              />
            </FormGroup>
            <div className={cx(s.searchToolTip, cs.spaceTop2, cs.spaceBottom4)}>
              <img src={locationIcon} className={'commonIconSpace'} />
              <span className={cx(s.locationTipCss, cs.commonMediumText)}><FormattedMessage {...messages.pricingDescription} /></span>
            </div>
            {/* Precio por hora - solo visible para botes */}
            {categoryConfig.allowHourlyBooking && (
              <div className={cx(s.pricingTypeContainer)}>
                <FormGroup className={cx(s.pricingTypeGroup)}>
                  <ControlLabel className={s.landingLabel}>
                    <FormattedMessage {...messages.dailyPricing} />
                  </ControlLabel>
                  <Field
                    name="hourlyPrice"
                    type="text"
                    component={CommonFormComponent}
                    label={formatMessage(messages.hourPriceLabel2)}
                    inputClass={cx(s.formControlInput, s.jumboSelect, s.formControlInputMaxWidth)}
                    normalize={normalizePrice}
                  />
                </FormGroup>
              </div>
            )}

            <FormGroup className={cs.spaceBottom4}>
              <ControlLabel className={s.landingLabel}>
                <FormattedMessage {...messages.delivery} />
                <div className={s.infoIconCss}>
                  <img src={infoIcon} className={s.infoIcon} />
                  <div className={cx(s.infoContent, s.deliveryInfo, 'infoContentRTL')}>{formatMessage(messages.deliveryInfo)}</div>
                </div>
              </ControlLabel>

              <Field
                name="delivery"
                type="text"
                component={CommonFormComponent}
                label={formatMessage(messages.delivery)}
                inputClass={cx(s.formControlInput, s.jumboSelect, s.formControlInputMaxWidth)}
                normalize={normalizePrice}
              />
            </FormGroup>
            {
              isSecurityPreference &&
              <FormGroup className={cs.spaceBottom4}>
                <ControlLabel className={s.landingLabel}>
                  <FormattedMessage {...messages.securityDeposit} />
                  <div className={s.infoIconCss}>
                    <img src={infoIcon} className={s.infoIcon} />
                    <div className={cx(s.infoContent, 'infoContentRTL')}>{formatMessage(messages.infoContent)}</div>
                  </div>
                </ControlLabel>
                <Field
                  name="securityDeposit"
                  type="text"
                  component={CommonFormComponent}
                  label={formatMessage(messages.securityDeposit)}
                  inputClass={cx(s.formControlInput, s.jumboSelect, s.formControlInputMaxWidth)}
                  normalize={normalizePrice}
                />
              </FormGroup>
            }

            {/* Add-ons Section */}
            <AddonsManager
              listId={listId}
              addons={addons}
              onChange={this.handleAddonsChange}
            />
          </div>
          <FooterButton
            nextPage={nextPage}
            previousPage={previousPage}
            previousPagePath={"boat-rules"}
            nextPagePath={"discount"}
            formPage={formPage}
            step={step}
            isDisabled={isDisabled}
          />
        </form>
      </div>
    );
  }
}

Pricing = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(Pricing);

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  availableCurrencies: state.currency.availableCurrencies,
  siteSettingStatus: state.siteSettings.data,
  listId: state.form?.ListPlaceStep3?.values?.id ? parseInt(state.form.ListPlaceStep3.values.id, 10) : null,
  // Get categoryType from multiple sources - Step3 form values take priority
  categoryType: state.form?.ListPlaceStep3?.values?.categoryType ||
    state.form?.ListPlaceStep1?.values?.categoryType ||
    state?.location?.listingSteps?.listing?.categoryType || 'boat',
});

const mapDispatch = {
};

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
  graphql(GET_LISTING_ADDONS, {
    name: 'addonsData',
    options: (props) => ({
      variables: { listId: parseInt(props.listId, 10) || 0 },
      skip: !props.listId,
      fetchPolicy: 'network-only',
    }),
  }),
)(Pricing);
